let globalInfo = {
    appId: '',
    appSecret: '',
    style: '', // 可选 目前支持
    // 当前菜单信息 当菜单改变时要重新写入
    currentMenuInfo: {
        menuName: '',
        menuId: '',
    }
};

export let getGlobalInfo = function (){
    return globalInfo;
}

window.helpCenterSDK = {
    setBaseInfo(appId, appSecret, style){
        if(!appId || !appSecret){
            console.error("请传入对应业务条线appId和appSecret");
            return;
        }
        globalInfo.appId = appId;
        globalInfo.appSecret = appSecret;
        globalInfo.style = style || '';
    },
    setCurMenuInfo(menuName, menuId){
        if(!menuName || !menuId){
            console.error("请传入对应菜单名称和id")
            return;
        }

        globalInfo.currentMenuInfo.menuName = menuName;
        globalInfo.currentMenuInfo.menuId = menuId;
    }
}
